/**
 * Nimizo × Joy Wishlist — restyle add buttons + wishlist page to match theme.
 * Joy UI lives in shadow DOM; we inject CSS into each host.
 */
(function () {
  var FONT = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
  var CORAL = '#FF6B81';
  var CORAL_SOFT = '#FFF0F2';
  var MINT = '#57D3C5';
  var CHARCOAL = '#222222';
  var MUTED = '#6B7280';

  var BUTTON_STYLE_ID = 'nimizo-joy-wl-button-style';
  var PAGE_STYLE_ID = 'nimizo-joy-wl-page-style';
  var MODAL_STYLE_ID = 'nimizo-joy-wl-modal-style';
  var PRODUCT_CARD_STYLE_ID = 'nimizo-joy-wl-product-card-style';
  var SHARE_STYLE_ID = 'nimizo-joy-wl-share-style';
  var REMOVE_STYLE_ID = 'nimizo-joy-wl-remove-style';

  var buttonCss = [
    ':host{display:inline-block!important;line-height:0!important;}',
    ':host([type=\"product\"]){display:block!important;width:100%!important;line-height:normal!important;}',
    'button.Joy-Wishlist__Button,',
    '.Joy-Wishlist__Button{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'width:40px!important;height:40px!important;min-width:40px!important;padding:0!important;margin:0!important;',
    'border:1.5px solid rgba(34,34,34,0.08)!important;border-radius:50%!important;',
    'background:#fff!important;box-shadow:0 6px 16px rgba(34,34,34,0.1)!important;',
    'cursor:pointer!important;box-sizing:border-box!important;',
    'transition:transform .2s ease,background-color .2s ease,border-color .2s ease,box-shadow .2s ease!important;',
    '--joy-wl-button-bg:#fff!important;',
    '--joy-wl-button-border:transparent!important;',
    '--joy-wl-button-color:' + CORAL + '!important;',
    '--joy-wl-button-icon-color:' + CORAL + '!important;',
    '--joy-wl-tooltip-color:#fff!important;',
    '--joy-wl-tooltip-bg:' + CHARCOAL + '!important;',
    '}',
    'button.Joy-Wishlist__Button:hover,',
    '.Joy-Wishlist__Button:hover{',
    'transform:translateY(-1px) scale(1.04)!important;',
    'background:' + CORAL_SOFT + '!important;',
    'border-color:rgba(255,107,129,0.35)!important;',
    'box-shadow:0 10px 22px rgba(255,107,129,0.22)!important;',
    '}',
    '.Joy-Wishlist-WishlistButton__Icon{',
    'display:flex!important;align-items:center!important;justify-content:center!important;',
    'color:' + CORAL + '!important;line-height:0!important;',
    '}',
    '.Joy-Wishlist-WishlistButton__Icon svg{width:20px!important;height:20px!important;display:block!important;}',
    '.Joy-Wishlist-WishlistButton__Icon svg path{',
    'fill:none!important;stroke:' + CORAL + '!important;stroke-width:1.9!important;',
    '}',
    'button.Joy-Wishlist__Button.--added .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button[aria-pressed=\"true\"] .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button[aria-label*=\"Added\"] .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button[aria-label*=\"added\"] .Joy-Wishlist-WishlistButton__Icon svg path,',
    '.Joy-Wishlist__Button.--Active .Joy-Wishlist-WishlistButton__Icon svg path{',
    'fill:' + CORAL + '!important;stroke:' + CORAL + '!important;',
    '}',
    '.Joy-Wishlist__Tooltip{',
    'font-family:' + FONT + '!important;font-size:0.72rem!important;font-weight:650!important;',
    'border-radius:999px!important;padding:0.35rem 0.65rem!important;',
    '}',
    /* Product page button — Buy it now style: heart left + label right */
    ':host([type=\"product\"]) button.Joy-Wishlist__Button,',
    ':host([type=\"product\"]) .Joy-Wishlist__Button,',
    'button.Joy-Wishlist__Button.--sizeLarge,',
    'button.Joy-Wishlist__Button.--FullWidth,',
    'button.Joy-Wishlist__Button.--fullWidth{',
    'width:100%!important;min-width:0!important;height:auto!important;min-height:52px!important;',
    'padding:0.85rem 1.35rem!important;border-radius:999px!important;gap:0.55rem!important;',
    'font-family:' + FONT + '!important;font-size:1rem!important;font-weight:700!important;',
    'background:#fff!important;color:' + CHARCOAL + '!important;',
    'border:1.5px solid rgba(34,34,34,0.12)!important;',
    'box-shadow:0 6px 18px rgba(34,34,34,0.06)!important;',
    'transform:none!important;',
    '--joy-wl-button-bg:#fff!important;',
    '--joy-wl-button-border:transparent!important;',
    '--joy-wl-button-color:' + CHARCOAL + '!important;',
    '--joy-wl-button-icon-color:' + CORAL + '!important;',
    '}',
    ':host([type=\"product\"]) button.Joy-Wishlist__Button:hover,',
    ':host([type=\"product\"]) .Joy-Wishlist__Button:hover,',
    'button.Joy-Wishlist__Button.--sizeLarge:hover,',
    'button.Joy-Wishlist__Button.--FullWidth:hover,',
    'button.Joy-Wishlist__Button.--fullWidth:hover{',
    'transform:translateY(-2px)!important;',
    'background:#fff!important;',
    'border-color:' + CHARCOAL + '!important;',
    'box-shadow:0 10px 22px rgba(34,34,34,0.1)!important;',
    '}',
    /* Heart left, text right */
    ':host([type=\"product\"]) .Joy-Wishlist-WishlistButton__Icon,',
    'button.Joy-Wishlist__Button.--sizeLarge .Joy-Wishlist-WishlistButton__Icon,',
    'button.Joy-Wishlist__Button.--FullWidth .Joy-Wishlist-WishlistButton__Icon,',
    'button.Joy-Wishlist__Button.--fullWidth .Joy-Wishlist-WishlistButton__Icon{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'order:0!important;flex-shrink:0!important;color:' + CORAL + '!important;',
    '}',
    ':host([type=\"product\"]) .Joy-Wishlist-WishlistButton__Text,',
    'button.Joy-Wishlist__Button.--fullWidth .Joy-Wishlist-WishlistButton__Text,',
    'button.Joy-Wishlist__Button.--FullWidth .Joy-Wishlist-WishlistButton__Text,',
    'button.Joy-Wishlist__Button.--sizeLarge .Joy-Wishlist-WishlistButton__Text{',
    'display:inline-block!important;order:1!important;',
    'font-family:' + FONT + '!important;font-size:1rem!important;font-weight:700!important;',
    'letter-spacing:-0.01em!important;line-height:1.2!important;',
    'color:' + CHARCOAL + '!important;white-space:nowrap!important;',
    '}',
    ':host([type=\"product\"]) .Joy-Wishlist-WishlistButton__Icon svg{',
    'width:22px!important;height:22px!important;',
    '}',
    ':host([type=\"product\"]) .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button.--sizeLarge .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button.--FullWidth .Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button.--fullWidth .Joy-Wishlist-WishlistButton__Icon svg path{',
    'stroke:' + CORAL + '!important;fill:none!important;stroke-width:1.8!important;',
    '}',
    ':host([type=\"product\"]) button.Joy-Wishlist__Button.--added .Joy-Wishlist-WishlistButton__Icon svg path,',
    ':host([type=\"product\"]) button.Joy-Wishlist__Button[aria-pressed=\"true\"] .Joy-Wishlist-WishlistButton__Icon svg path,',
    ':host([type=\"product\"]) button.Joy-Wishlist__Button[aria-label*=\"Added\"] .Joy-Wishlist-WishlistButton__Icon svg path,',
    ':host([type=\"product\"]) button.Joy-Wishlist__Button[aria-label*=\"added\"] .Joy-Wishlist-WishlistButton__Icon svg path{',
    'fill:' + CORAL + '!important;stroke:' + CORAL + '!important;',
    '}'
  ].join('');

  var pageCss = [
    ':host{display:block!important;font-family:' + FONT + '!important;color:' + CHARCOAL + '!important;}',
    '.Joy-Wishlist-ManagePage__Wrapper{',
    'background:transparent!important;',
    '--wl-background-page:transparent!important;',
    '--wl-text-page:' + CHARCOAL + '!important;',
    '}',
    '.Joy-Wishlist-ManagePage__Padding{padding:0!important;}',
    '.Joy-Wishlist-ManagePage__Container{max-width:100%!important;margin:0!important;}',
    '.Joy-Wishlist-ManagePage__Header--Wrapper{display:none!important;}',
    '.Joy-Wishlist-ManagePage__Header{display:none!important;}',
    '.Joy-Wishlist-ManagePage__Title{display:none!important;}',
    '.Joy-Wishlist-ManagePage__Description{display:none!important;}',
    '.Joy-Wishlist-SignInBanner{',
    'display:flex!important;align-items:center!important;gap:0.85rem!important;flex-wrap:wrap!important;',
    'padding:1rem 1.15rem!important;margin:0 0 1.25rem!important;',
    'border-radius:18px!important;',
    'background:linear-gradient(135deg,' + CORAL_SOFT + ',#EBF8F6)!important;',
    'border:1px solid rgba(255,107,129,0.18)!important;',
    '}',
    '.Joy-Wishlist-SignInBanner__Icon{',
    'width:40px!important;height:40px!important;border-radius:50%!important;',
    'display:grid!important;place-items:center!important;background:#fff!important;',
    'color:' + CORAL + '!important;flex-shrink:0!important;',
    '}',
    '.Joy-Wishlist-SignInBanner__Title{',
    'display:block!important;font-family:' + FONT + '!important;font-weight:800!important;',
    'font-size:0.95rem!important;color:' + CHARCOAL + '!important;',
    '}',
    '.Joy-Wishlist-SignInBanner__Subtitle{',
    'display:block!important;font-family:' + FONT + '!important;font-size:0.82rem!important;',
    'color:' + MUTED + '!important;margin-top:0.15rem!important;',
    '}',
    '.Joy-Wishlist-SignInBanner__Button{',
    'margin-left:auto!important;display:inline-flex!important;align-items:center!important;gap:0.35rem!important;',
    'padding:0.65rem 1.1rem!important;border-radius:999px!important;',
    'background:' + CORAL + '!important;color:#fff!important;text-decoration:none!important;',
    'font-family:' + FONT + '!important;font-size:0.85rem!important;font-weight:700!important;',
    'box-shadow:0 6px 16px rgba(255,107,129,0.28)!important;',
    '}',
    '.Joy-Wishlist-ActionRow{',
    'display:flex!important;align-items:center!important;justify-content:space-between!important;',
    'gap:0.75rem!important;margin:0 0 1rem!important;',
    '}',
    '.Joy-Wishlist-ActionRow__Count{',
    'display:inline-flex!important;align-items:center!important;gap:0.4rem!important;',
    'font-family:' + FONT + '!important;font-weight:700!important;font-size:0.9rem!important;',
    'color:' + CHARCOAL + '!important;',
    '}',
    '.Joy-Wishlist-ActionRow__Count svg{width:18px!important;height:18px!important;color:' + CORAL + '!important;}',
    '.Joy-Wishlist-EmptyState{',
    'text-align:center!important;padding:2.5rem 1.25rem!important;',
    'border-radius:24px!important;background:#fff!important;',
    'border:1px solid rgba(34,34,34,0.08)!important;',
    'box-shadow:0 14px 36px rgba(34,34,34,0.05)!important;',
    '}',
    '.Joy-Wishlist-EmptyState__Illustration{',
    'width:72px!important;height:72px!important;margin:0 auto 1rem!important;',
    'border-radius:50%!important;display:grid!important;place-items:center!important;',
    'background:' + CORAL_SOFT + '!important;color:' + CORAL + '!important;',
    '}',
    '.Joy-Wishlist-EmptyState__Illustration svg{width:32px!important;height:32px!important;}',
    '.Joy-Wishlist-EmptyState__Title{',
    'font-family:' + FONT + '!important;font-size:1.25rem!important;font-weight:800!important;',
    'color:' + CHARCOAL + '!important;margin:0 0 0.45rem!important;',
    '}',
    '.Joy-Wishlist-EmptyState__Subtitle{',
    'font-family:' + FONT + '!important;font-size:0.95rem!important;line-height:1.5!important;',
    'color:' + MUTED + '!important;margin:0 auto 1.15rem!important;max-width:28rem!important;',
    '}',
    '.Joy-Wishlist-EmptyState__Cta{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'padding:0.75rem 1.35rem!important;border-radius:999px!important;',
    'background:' + CORAL + '!important;color:#fff!important;',
    'font-family:' + FONT + '!important;font-size:0.9rem!important;font-weight:700!important;',
    'box-shadow:0 8px 20px rgba(255,107,129,0.28)!important;cursor:pointer!important;',
    '}',
    /* Share button host sits in light of this shadow */
    'joy-wishlist-share-button{display:inline-block!important;}',
    /* Product grid cards inside wishlist */
    '.Joy-Wishlist-ManagePage__ProductGrid{',
    'display:grid!important;grid-template-columns:repeat(auto-fill,minmax(220px,1fr))!important;',
    'gap:1.25rem!important;',
    '}',
    '.Joy-Wishlist-Product__Wrapper,',
    'joy-wishlist-product{',
    'border-radius:20px!important;border:1px solid rgba(34,34,34,0.08)!important;',
    'overflow:hidden!important;background:#fff!important;',
    'box-shadow:0 8px 24px rgba(34,34,34,0.05)!important;',
    'font-family:' + FONT + '!important;',
    '--joy-wl-page-btn-bg:' + CORAL + '!important;',
    '--joy-wl-page-btn-color:#fff!important;',
    '--wl-text-page:' + CHARCOAL + '!important;',
    '}',
    '@media (max-width:768px){',
    '.Joy-Wishlist-SignInBanner{flex-direction:column!important;align-items:flex-start!important;}',
    '.Joy-Wishlist-SignInBanner__Button{margin-left:0!important;width:100%!important;justify-content:center!important;}',
    '}'
  ].join('');

  var productCardCss = [
    ':host{display:block!important;font-family:' + FONT + '!important;}',
    '.Joy-Wishlist-Product__Wrapper{',
    'border-radius:20px!important;border:1px solid rgba(34,34,34,0.08)!important;',
    'overflow:hidden!important;background:#fff!important;',
    'box-shadow:0 8px 24px rgba(34,34,34,0.05)!important;',
    '--joy-wl-page-btn-bg:' + CORAL + '!important;',
    '--joy-wl-page-btn-color:#ffffff!important;',
    '--wl-text-page:' + CHARCOAL + '!important;',
    '}',
    '.Joy-Wishlist-Product__Image--Wrapper{position:relative!important;background:linear-gradient(135deg,#f8f9fa,#fff0f2)!important;}',
    '.Joy-Wishlist-Product__RemoveBtn{',
    'position:absolute!important;top:10px!important;right:10px!important;z-index:3!important;',
    '}',
    '.Joy-Wishlist-Product__Title{',
    'font-family:' + FONT + '!important;font-weight:700!important;font-size:0.95rem!important;',
    'color:' + CHARCOAL + '!important;text-decoration:none!important;',
    '}',
    '.Joy-Wishlist-Product__Price{',
    'font-family:' + FONT + '!important;font-weight:800!important;color:' + CHARCOAL + '!important;',
    '}',
    '.Joy-Wishlist-Product__ComparePrice{',
    'font-family:' + FONT + '!important;color:' + MUTED + '!important;text-decoration:line-through!important;',
    '}',
    /* Add to Cart — coral pill like theme ATC */
    'button.Joy-Wishlist__Button{',
    'display:flex!important;align-items:center!important;justify-content:center!important;',
    'width:100%!important;min-height:48px!important;margin-top:0.75rem!important;',
    'padding:0.75rem 1rem!important;border:none!important;border-radius:999px!important;',
    'background:' + CORAL + '!important;color:#fff!important;',
    'font-family:' + FONT + '!important;font-size:0.9rem!important;font-weight:700!important;',
    'box-shadow:0 8px 20px rgba(255,107,129,0.28)!important;cursor:pointer!important;',
    'transition:transform .2s ease,box-shadow .2s ease,background .2s ease!important;',
    '}',
    'button.Joy-Wishlist__Button:hover{',
    'transform:translateY(-1px)!important;background:#FF526C!important;',
    'box-shadow:0 12px 26px rgba(255,107,129,0.34)!important;',
    '}',
    '.Joy-Wishlist-Text{color:#fff!important;font-family:' + FONT + '!important;font-weight:700!important;}'
  ].join('');

  var shareCss = [
    ':host{display:inline-block!important;font-family:' + FONT + '!important;}',
    'button{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:0.4rem!important;',
    'padding:0.65rem 1.1rem!important;border-radius:999px!important;',
    'border:1.5px solid rgba(34,34,34,0.12)!important;background:#fff!important;',
    'color:' + CHARCOAL + '!important;',
    'font-family:' + FONT + '!important;font-size:0.85rem!important;font-weight:700!important;',
    'box-shadow:0 6px 16px rgba(34,34,34,0.06)!important;cursor:pointer!important;',
    'transition:transform .2s ease,border-color .2s ease,box-shadow .2s ease!important;',
    '}',
    'button:hover{',
    'transform:translateY(-1px)!important;border-color:' + CHARCOAL + '!important;',
    'box-shadow:0 10px 22px rgba(34,34,34,0.1)!important;',
    '}',
    'button svg{width:16px!important;height:16px!important;stroke:' + CHARCOAL + '!important;}'
  ].join('');

  /* Remove/toggle heart on wishlist product cards */
  var wishlistRemoveCss = [
    ':host{display:block!important;line-height:0!important;}',
    'button.Joy-Wishlist__Button,',
    '.Joy-Wishlist__Button{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'width:40px!important;height:40px!important;min-width:40px!important;padding:0!important;margin:0!important;',
    'border:1.5px solid rgba(34,34,34,0.08)!important;border-radius:50%!important;',
    'background:#fff!important;box-shadow:0 6px 16px rgba(34,34,34,0.1)!important;',
    'cursor:pointer!important;',
    '--joy-wl-button-bg:#fff!important;',
    '--joy-wl-button-icon-color:' + CORAL + '!important;',
    '}',
    '.Joy-Wishlist-WishlistButton__Icon{color:' + CORAL + '!important;}',
    '.Joy-Wishlist-WishlistButton__Icon svg{width:20px!important;height:20px!important;}',
    '.Joy-Wishlist-WishlistButton__Icon svg path,',
    'button.Joy-Wishlist__Button .Joy-Wishlist-WishlistButton__Icon svg path{',
    'fill:' + CORAL + '!important;stroke:' + CORAL + '!important;',
    '}',
    '.Joy-Wishlist-WishlistButton__Text{display:none!important;}'
  ].join('');

  var modalCss = [
    ':host{font-family:' + FONT + '!important;}',
    '[class*=\"Modal\"], [class*=\"Dialog\"], [class*=\"Popup\"]{',
    'font-family:' + FONT + '!important;',
    '}',
    'button, .btn, [class*=\"Button\"]{',
    'border-radius:999px!important;font-family:' + FONT + '!important;font-weight:700!important;',
    '}',
    'input, textarea{',
    'border-radius:999px!important;font-family:' + FONT + '!important;',
    'border:1.5px solid rgba(34,34,34,0.1)!important;',
    '}'
  ].join('');

  function inject(root, id, css) {
    if (!root) return;
    var existing = root.getElementById(id);
    if (existing) {
      if (existing.textContent !== css) existing.textContent = css;
      return;
    }
    var style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    root.appendChild(style);
  }

  function isPdpButton(host) {
    if (!host) return false;
    var type = (host.getAttribute('type') || '').toLowerCase();
    return type === 'product' || !!(host.closest('.pdp-buy-engine') || host.closest('.nimizo-pdp-section'));
  }

  function isWishlistAdded(btn) {
    if (!btn) return false;
    var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.getAttribute('title') || '')).toLowerCase();
    return !!(
      btn.classList.contains('--added') ||
      btn.classList.contains('--Active') ||
      btn.classList.contains('is-added') ||
      btn.getAttribute('aria-pressed') === 'true' ||
      label.indexOf('added') !== -1 ||
      label.indexOf('remove') !== -1
    );
  }

  function syncPdpLabel(host) {
    if (!host || !host.shadowRoot || !isPdpButton(host)) return;
    var btn = host.shadowRoot.querySelector('button.Joy-Wishlist__Button, .Joy-Wishlist__Button, button');
    if (!btn) return;

    var added = isWishlistAdded(btn);
    var label = added ? 'Added to Wishlist' : 'Add to Wishlist';
    var textEl = host.shadowRoot.querySelector('.Joy-Wishlist-WishlistButton__Text');

    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className = 'Joy-Wishlist-WishlistButton__Text';
      btn.appendChild(textEl);
    }

    if (textEl.textContent !== label) textEl.textContent = label;
    try {
      btn.setAttribute('aria-label', label);
    } catch (e) {}
  }

  function isCardButton(host) {
    if (!host) return true;
    var type = (host.getAttribute('type') || '').toLowerCase();
    if (type === 'product') return false;
    if (host.closest('.pdp-buy-engine') || host.closest('.nimizo-pdp-section')) return false;
    return !!(
      host.closest('.product-card') ||
      host.closest('.Joy-WishlistProductCard') ||
      host.closest('.product-card__image-wrapper') ||
      host.closest('.collection-products-grid') ||
      host.closest('.nimizo-products') ||
      type === 'product-card' ||
      type === 'collection' ||
      type === 'home-collection' ||
      type === 'homecollection'
    );
  }

  function setImportant(host, prop, value) {
    if (host.style.getPropertyValue(prop) === value && host.style.getPropertyPriority(prop) === 'important') {
      return;
    }
    host.style.setProperty(prop, value, 'important');
  }

  function clearInlinePlacement(host) {
    try {
      host.style.removeProperty('position');
      host.style.removeProperty('top');
      host.style.removeProperty('right');
      host.style.removeProperty('left');
      host.style.removeProperty('z-index');
      host.style.removeProperty('display');
      host.style.removeProperty('margin');
      host.style.removeProperty('width');
      host.style.removeProperty('height');
      host.style.removeProperty('opacity');
      host.style.removeProperty('visibility');
      host.style.removeProperty('pointer-events');
      host.style.removeProperty('overflow');
    } catch (e) {}
  }

  /* --- Product JSON fallback (Shopify CLI theme-dev often 401s /products/*.json) --- */
  var productCache = Object.create(null);

  function readEmbeddedProducts() {
    document.querySelectorAll('script.nimizo-wl-product-data[data-handle]').forEach(function (node) {
      var handle = node.getAttribute('data-handle');
      if (!handle || productCache[handle]) return;
      try {
        productCache[handle] = JSON.parse(node.textContent);
      } catch (e) {}
    });
  }

  function productFromAnalytics(handle) {
    try {
      var list = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.products) || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].handle === handle) {
          return {
            id: list[i].id,
            title: list[i].variants && list[i].variants[0] && list[i].variants[0].name,
            handle: handle,
            variants: (list[i].variants || []).map(function (v) {
              return {
                id: v.id,
                title: v.public_title || v.name,
                name: v.name,
                price: v.price,
                available: true
              };
            }),
            available: true,
            price: list[i].variants && list[i].variants[0] && list[i].variants[0].price
          };
        }
      }
    } catch (e) {}
    return null;
  }

  function resolveProduct(handle) {
    readEmbeddedProducts();
    return productCache[handle] || productFromAnalytics(handle) || null;
  }

  function jsonResponse(data, status) {
    return new Response(JSON.stringify(data), {
      status: status || 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function installProductJsonFallback() {
    if (window.__nimizoWlFetchPatched) return;
    window.__nimizoWlFetchPatched = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var match = url.match(/\/products\/([^/?#]+)\.json(?:$|\?)/i);
      if (!match) return nativeFetch(input, init);

      return nativeFetch(input, init).then(function (res) {
        if (res.ok) return res;
        var handle = decodeURIComponent(match[1]);
        var product = resolveProduct(handle);
        if (!product) return res;
        return jsonResponse({ product: product }, 200);
      }).catch(function (err) {
        var handle = decodeURIComponent(match[1]);
        var product = resolveProduct(handle);
        if (product) return jsonResponse({ product: product }, 200);
        throw err;
      });
    };
  }

  function hideCardButton(host) {
    try {
      setImportant(host, 'display', 'none');
      setImportant(host, 'visibility', 'hidden');
      setImportant(host, 'pointer-events', 'none');
      setImportant(host, 'opacity', '0');
      setImportant(host, 'width', '0');
      setImportant(host, 'height', '0');
      setImportant(host, 'overflow', 'hidden');
      setImportant(host, 'position', 'absolute');
    } catch (e) {}
  }

  function isWishlistPageRemoveButton(host) {
    return !!(host.closest && (
      host.closest('joy-wishlist-product') ||
      (host.getRootNode && host.getRootNode().host && (
        host.getRootNode().host.tagName === 'JOY-WISHLIST-PRODUCT' ||
        (host.getRootNode().host.closest && host.getRootNode().host.closest('joy-wishlist-product'))
      ))
    ));
  }

  function styleButtons() {
    document.querySelectorAll('joy-wishlist-button').forEach(function (host) {
      /* Collection / card hearts on storefront — hide.
         Keep remove hearts that live inside the wishlist page product cards. */
      if (isCardButton(host) && !isWishlistPageRemoveButton(host)) {
        hideCardButton(host);
        return;
      }

      if (!host.shadowRoot) return;
      inject(host.shadowRoot, BUTTON_STYLE_ID, buttonCss);

      /* PDP only — normal flow under buy buttons */
      clearInlinePlacement(host);
      try {
        setImportant(host, 'display', 'block');
        setImportant(host, 'width', '100%');
        setImportant(host, 'margin', '0.75rem 0 0');
        setImportant(host, 'position', 'static');
        setImportant(host, 'visibility', 'visible');
        setImportant(host, 'pointer-events', 'auto');
        setImportant(host, 'opacity', '1');
        setImportant(host, 'height', 'auto');
        setImportant(host, 'overflow', 'visible');
      } catch (e) {}

      syncPdpLabel(host);
    });
  }

  function styleNestedWishlistUi(pageHost) {
    if (!pageHost || !pageHost.shadowRoot) return;

    pageHost.shadowRoot.querySelectorAll('joy-wishlist-share-button').forEach(function (share) {
      if (!share.shadowRoot) return;
      inject(share.shadowRoot, SHARE_STYLE_ID, shareCss);
    });

    pageHost.shadowRoot.querySelectorAll('joy-wishlist-product').forEach(function (product) {
      if (!product.shadowRoot) return;
      inject(product.shadowRoot, PRODUCT_CARD_STYLE_ID, productCardCss);

      product.shadowRoot.querySelectorAll('joy-wishlist-button').forEach(function (btn) {
        if (!btn.shadowRoot) return;
        inject(btn.shadowRoot, REMOVE_STYLE_ID, wishlistRemoveCss);
        try {
          clearInlinePlacement(btn);
          setImportant(btn, 'display', 'block');
          setImportant(btn, 'visibility', 'visible');
          setImportant(btn, 'pointer-events', 'auto');
          setImportant(btn, 'opacity', '1');
          setImportant(btn, 'width', 'auto');
          setImportant(btn, 'height', 'auto');
          setImportant(btn, 'overflow', 'visible');
          setImportant(btn, 'position', 'static');
        } catch (e) {}
      });
    });
  }

  function stylePages() {
    document.querySelectorAll('joy-wishlist-page').forEach(function (host) {
      if (!host.shadowRoot) return;
      inject(host.shadowRoot, PAGE_STYLE_ID, pageCss);
      styleNestedWishlistUi(host);
    });
  }

  function styleModals() {
    document.querySelectorAll('joy-wishlist-login-modal, joy-wishlist-recovery-form').forEach(function (host) {
      if (!host.shadowRoot) return;
      inject(host.shadowRoot, MODAL_STYLE_ID, modalCss);
    });
  }

  var scheduled = null;
  function run() {
    readEmbeddedProducts();
    styleButtons();
    stylePages();
    styleModals();
  }

  function scheduleRun() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      run();
    });
  }

  installProductJsonFallback();
  run();
  document.addEventListener('DOMContentLoaded', run);
  var obs = new MutationObserver(function () { scheduleRun(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
